module.exports = __webpack_public_path__ + "img/season.af157bc4.svg";